import React from 'react';
import moment from 'moment';
import Paragraph from "../custom-antd/Typegraphy";
import { STYLE_PREFIX } from "../../utils/const";
import "./style.less";
var MessageCard = function MessageCard(_ref) {
  var mesaage = _ref.mesaage,
    readMessage = _ref.readMessage,
    handleMessageClick = _ref.handleMessageClick;
  var id = mesaage.id,
    secondLabelIcon = mesaage.secondLabelIcon,
    title = mesaage.title,
    readStatus = mesaage.readStatus,
    content = mesaage.content,
    secondLabelName = mesaage.secondLabelName,
    updateTime = mesaage.updateTime,
    buttonText = mesaage.buttonText,
    jumpUrl = mesaage.jumpUrl;
  var handleClick = function handleClick(url) {
    window.open(url);
    readMessage(id);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card"),
    onClick: handleMessageClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card-header")
  }, /*#__PURE__*/React.createElement("img", {
    className: "avatar",
    src: secondLabelIcon,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card-header_title")
  }, title), readStatus === 2 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card-header_spot")
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card-contents")
  }, /*#__PURE__*/React.createElement(Paragraph, {
    content: content
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card-footer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "card-footer_content")
  }, /*#__PURE__*/React.createElement("span", null, secondLabelName), /*#__PURE__*/React.createElement("span", {
    className: "card-footer_content__spot"
  }, "\xB7"), /*#__PURE__*/React.createElement("span", null, moment(updateTime).format('YYYY-MM-DD HH:mm:ss'))), buttonText && jumpUrl && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleClick(jumpUrl);
    },
    className: "".concat(STYLE_PREFIX, "card-footer_content__btn ").concat(readStatus === 1 ? 'link' : '')
  }, buttonText)));
};
export default MessageCard;